import React from 'react'

import { useAPIGetProfilePersonalData } from 'api/profile/useAPIProfile'

export const usePersonalData = () => {
  const { data: personalDataResponse, status: personalDataFetchStatus } =
    useAPIGetProfilePersonalData()

  const personalData = React.useMemo(
    () => personalDataResponse?.data,
    [personalDataResponse?.data]
  )

  const hasPersonalData = Object.values(personalData ?? {}).some((item) =>
    Boolean(item)
  )

  return {
    personalData,
    personalDataFetchStatus,
    hasPersonalData,
  }
}
